module.exports = __webpack_public_path__ + "img/ep7-7a.3d9d4eba.png";